import Debugger from './Debugger.vue';
export default Debugger;
